import { faker } from '@faker-js/faker';
import { TMutatePromosResponse } from './bulkPromoUpload.types';

export const mutatePromosMock: TMutatePromosResponse = {
  promo_id: faker.datatype.uuid(),
};
